import { ButtonTertiary } from "@nova/component-btn"
import { Dropdown } from "@nova/component-dropdown"
import { ButtonSplit } from "@nova/ds-component-button-split"
import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { ScrollableArea } from "@nova/component-scrollable-area"
import { useState } from "react"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"
import { usePilots } from "../pilots/PilotQueries"
import { NovaSpinner } from "@nova/component-nova-spinner"
import classNames from "classnames"

export interface PilotFilterValue {
    id: string
    name: string
}

interface PilotFilterProps {
    value: PilotFilterValue | undefined
    onChange: (value: PilotFilterValue | undefined) => void
}

export const PilotFilter = ({ value, onChange }: PilotFilterProps) => {
    const [search, setSearch] = useState("")
    const { pilots, isLoading: isLoadingPilots } = usePilots({ search })

    return (
        <Dropdown
            onOpenChange={(open) => {
                if (!open) {
                    setSearch("")
                }
            }}
        >
            <Dropdown.Trigger as="div" className="group">
                {value ? (
                    <ButtonSplit
                        label={value.name}
                        onRightClick={(e) => {
                            e.stopPropagation()
                            onChange(undefined)
                        }}
                    />
                ) : (
                    <ButtonTertiary
                        title="Pilot"
                        RightIcon={Icons.ArrowDropdown}
                        rightIconClassName="transition-transform group-data-[state=open]:rotate-180"
                        className="group-data-[state=open]:!border-gray-300 group-data-[state=open]:!text-gray-0"
                    />
                )}
            </Dropdown.Trigger>
            <Dropdown.Menu className="w-[300px]">
                <div className="p-3 pb-2 text-gray-100">
                    <InputOutlined
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        placeholder="Search"
                        leftItem={<Icons.Icon Icon={Icons.MagnifyingGlass} className="mr-1" />}
                        autoFocus
                    />
                </div>
                <ScrollableArea className="max-h-[300px] pb-2">
                    {isLoadingPilots ? (
                        <div className="flex justify-center">
                            <NovaSpinner width={16} height={16} />
                        </div>
                    ) : !pilots?.length ? (
                        <div className="flex justify-center text-white">No pilots found</div>
                    ) : (
                        pilots.map((pilot) => (
                            <Dropdown.ButtonItem
                                key={pilot.userId}
                                onClick={() =>
                                    onChange({
                                        id: pilot.userId,
                                        name: pilot.fullName ?? pilot.userId,
                                    })
                                }
                                className={classNames("flex items-center gap-3", {
                                    "bg-white-200": value?.id === pilot.userId,
                                })}
                            >
                                <div className="w-8 min-w-[32px] aspect-square rounded-lg overflow-hidden">
                                    <ProfilePhoto
                                        userId={pilot.userId!}
                                        fullName={pilot.fullName ?? ""}
                                    />
                                </div>
                                <span className="text-sm text-white">{pilot.fullName}</span>
                            </Dropdown.ButtonItem>
                        ))
                    )}
                </ScrollableArea>
            </Dropdown.Menu>
        </Dropdown>
    )
}
